// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c4f0480","732":"b1191446","977":"d0fdb946"}[chunkId] + ".chunk.js";
};